"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appWithI18Next = void 0;
const i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
const next_i18next_1 = require("next-i18next");
const config_1 = __importDefault(require("next/config"));
const { publicRuntimeConfig = {} } = (0, config_1.default)();
const { translationEnvironment } = publicRuntimeConfig;
const VERSION = process.env.VERSION || `dev`;
const backend = {
    loadPath: `/locales/{{lng}}/{{ns}}.json`,
    addPath: `/locales/{{lng}}/{{ns}}.missing.json`,
};
if (!process.browser) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { resolve } = require('path');
    Object.assign(backend, {
        loadPath: resolve(process.cwd(), `/public/locales/{{lng}}/{{ns}}.json`),
        addPath: resolve(process.cwd(), `/public/locales/{{lng}}/{{ns}}.missing.json`),
    });
}
function appWithI18Next(userConfig) {
    const overrideConfig = Object.assign(Object.assign({ lng: translationEnvironment ? 'cimode' : undefined, appendNamespaceToCIMode: !!translationEnvironment }, userConfig), { react: {
            useSuspense: false,
            // wait: true, // @todo why it's removed?
        }, use: [i18next_http_backend_1.default], backend: Object.assign(Object.assign({}, backend), { queryStringParams: { v: `${VERSION}` }, reloadInterval: false }), partialBundledLanguages: true });
    return function appWithI18NextWrapFn(WrappedAppComponent) {
        return (0, next_i18next_1.appWithTranslation)(WrappedAppComponent, overrideConfig);
    };
}
exports.appWithI18Next = appWithI18Next;
//# sourceMappingURL=app-with-lang.js.map